/* ============================================================
   AL MALEH HOUSE — Enquiry List
   Client-side multi-piece WhatsApp enquiry. Stored in localStorage only.
   No cart, no checkout, no prices.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'amh-enquiry-list-v1';
  var MAX = 15;

  var drawer = document.getElementById('EnquiryDrawer');
  if (!drawer) return;

  var waNumber   = drawer.getAttribute('data-wa-number') || '212610813018';
  var itemsEl    = drawer.querySelector('[data-enquiry-items]');
  var emptyEl    = drawer.querySelector('[data-enquiry-empty]');
  var limitEl    = drawer.querySelector('[data-enquiry-limit]');
  var footEl     = drawer.querySelector('[data-enquiry-foot]');
  var sendEl     = drawer.querySelector('[data-enquiry-send]');
  var locationEl = drawer.querySelector('[data-enquiry-location]');
  var clearEl    = drawer.querySelector('[data-enquiry-clear]');
  var lastFocus  = null;

  /* ---------- storage (always guarded: private mode / blocked storage) ---------- */
  function isSafeUrl(u) { return typeof u === 'string' && /^(https?:)?\/\//.test(u); }
  function isValid(it) {
    return it && typeof it.title === 'string' && it.title && isSafeUrl(it.url);
  }
  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(isValid).slice(0, MAX) : [];
    } catch (e) { return []; }
  }
  function save() {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* in-memory only */ }
  }

  var list = load();

  function indexOfUrl(url) {
    for (var i = 0; i < list.length; i++) { if (list[i].url === url) return i; }
    return -1;
  }

  /* ---------- product data (read-only, output by Liquid on product pages) ---------- */
  var product = null;
  var dataEl = document.getElementById('EnquiryProductData');
  if (dataEl) {
    try { product = JSON.parse(dataEl.textContent); } catch (e) { product = null; }
    if (!isValid(product)) product = null;
  }

  /* ---------- WhatsApp message ---------- */
  function buildMessage() {
    var lines = ['Hello Al Maleh House, I would like to enquire about these pieces:'];
    list.forEach(function (it, i) { lines.push((i + 1) + '. ' + it.title + ' — ' + it.url); });
    var where = locationEl ? locationEl.value.trim() : '';
    if (where) lines.push('Delivery to: ' + where);
    lines.push('Thank you.');
    return lines.join('\n');
  }
  function updateSendLink() {
    if (sendEl) sendEl.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(buildMessage());
  }

  /* ---------- rendering ---------- */
  function renderItems() {
    while (itemsEl.firstChild) itemsEl.removeChild(itemsEl.firstChild);
    list.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'enquiry-item';

      var thumb = document.createElement('a');
      thumb.className = 'enquiry-item-thumb';
      thumb.href = it.url;
      thumb.tabIndex = -1;
      thumb.setAttribute('aria-hidden', 'true');
      if (isSafeUrl(it.image)) {
        var img = document.createElement('img');
        img.src = it.image; img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64;
        thumb.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'enquiry-item-info';
      if (it.label) {
        var label = document.createElement('p');
        label.className = 'enquiry-item-label';
        label.textContent = it.label;
        info.appendChild(label);
      }
      var title = document.createElement('a');
      title.className = 'enquiry-item-title';
      title.href = it.url;
      title.textContent = it.title;
      info.appendChild(title);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'enquiry-item-remove';
      remove.setAttribute('aria-label', 'Remove ' + it.title);
      remove.textContent = '×';
      remove.addEventListener('click', function () { removeItem(it.url); });

      li.appendChild(thumb); li.appendChild(info); li.appendChild(remove);
      itemsEl.appendChild(li);
    });
  }

  function renderButtons() {
    var inList = product && indexOfUrl(product.url) !== -1;
    document.querySelectorAll('[data-enquiry-add]').forEach(function (btn) {
      btn.textContent = inList ? btn.getAttribute('data-label-added') : btn.getAttribute('data-label-add');
      btn.classList.toggle('is-added', !!inList);
      btn.setAttribute('aria-haspopup', inList ? 'dialog' : 'false');
    });
    if (inList || list.length < MAX) {
      document.querySelectorAll('[data-enquiry-add-note]').forEach(function (n) { n.hidden = true; });
    }
  }

  function render() {
    var n = list.length;
    document.querySelectorAll('[data-enquiry-count]').forEach(function (el) { el.textContent = String(n); });
    document.querySelectorAll('[data-enquiry-open]').forEach(function (el) {
      el.hidden = n === 0;
      el.setAttribute('aria-label', 'Enquiry list, ' + n + (n === 1 ? ' piece' : ' pieces'));
    });
    emptyEl.hidden = n > 0;
    footEl.hidden = n === 0;
    limitEl.hidden = n < MAX;
    renderItems();
    renderButtons();
    updateSendLink();
  }

  /* ---------- actions ---------- */
  function removeItem(url) {
    var i = indexOfUrl(url);
    if (i === -1) return;
    list.splice(i, 1);
    save(); render();
    if (!list.length) { var c = drawer.querySelector('.enquiry-drawer-close'); if (c) c.focus(); }
  }

  function onAddClick() {
    if (!product) return;
    if (indexOfUrl(product.url) !== -1) { openDrawer(); return; }
    if (list.length >= MAX) {
      document.querySelectorAll('[data-enquiry-add-note]').forEach(function (n) { n.hidden = false; });
      openDrawer();
      return;
    }
    list.push({ title: product.title, url: product.url, image: product.image || '', label: product.label || '' });
    save(); render();
  }

  /* ---------- drawer ---------- */
  function focusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('.enquiry-drawer-panel a[href], .enquiry-drawer-panel button, .enquiry-drawer-panel input'),
      function (el) { return !el.hidden && el.offsetParent !== null && el.tabIndex !== -1; }
    );
  }
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('enquiry-drawer-open');
    var c = drawer.querySelector('.enquiry-drawer-close');
    if (c) setTimeout(function () { c.focus(); }, 50);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('enquiry-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('[data-enquiry-add]')) { e.preventDefault(); onAddClick(); return; }
    if (t.closest('[data-enquiry-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-enquiry-close]')) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  if (clearEl) clearEl.addEventListener('click', function () {
    list = []; save(); render();
    var c = drawer.querySelector('.enquiry-drawer-close'); if (c) c.focus();
  });
  if (locationEl) locationEl.addEventListener('input', updateSendLink);

  // Keep several open tabs in step
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { list = load(); render(); }
  });

  render();
})();
